import Counter from "./Counter";
import dates from "componentsv2/tools/dates";
import SearchBar from "componentsv2/widgets/SearchBar";
import { useTable } from "storev2/tableStore";

function SearchWidget({ layout, storeId, count, getDomain, setSearchDomain }) {
  const searchables = [];
  for (const [field, attrs] of Object.entries(layout.fields)) {
    if (attrs.searchable) {
      searchables.push({
        name: field,
        type: attrs.type,
      });
    }
  }

  function makeSearchDomain(textMap) {
    const arrText = textMap.split(" ");
    const domain = [];
    for (const tw of arrText) {
      const clause = ["OR"];
      for (const field of searchables) {
        let field_name = field.name;
        if (field.type === "many2one") {
          field_name = `${field_name}.rec_name`;
          clause.push([field_name, "ilike", `%${tw}%`]);
        } else if (field.type === "date") {
          const n = dates.getTrytonDate2Js(tw);
          if (!Number.isNaN(n)) {
            clause.push([field_name, "=", tw]);
          }
        } else {
          clause.push([field_name, "ilike", `%${tw}%`]);
        }
      }
      domain.push(clause);
    }
    return domain;
  }

  async function handleSearch(textSearch, reset) {
    if (getDomain && setSearchDomain) {
      let searchPart = null;
      if (reset) {
        searchPart = null;
      } else if (searchables?.length > 0 && textSearch?.trim()) {
        searchPart = makeSearchDomain(textSearch);
      }

      setSearchDomain(searchPart);
      return;
    }

    const { reload } = useTable.getState();

    let domain = null;
    if (reset || !textSearch?.trim()) {
      domain = [];
    }
    if (searchables?.length > 0 && textSearch?.trim() && !reset) {
      domain = makeSearchDomain(textSearch, searchables);
    }
    if (!domain) return;
    const searchDomain = {
      search: domain,
    };
    await reload(storeId, searchDomain);
  }

  return (
    <div className="flex col-span-6 md:col-span-2">
      <SearchBar
        name="search-widget"
        handleSearch={handleSearch}
        size="w-full"
      />
      <Counter value={count} />
    </div>
  );
}

export default SearchWidget;
